import { SchematicAPI } from '../actions/schematicAPI';
import { ServerAPI } from '../actions/serverAPI';
import Constants from '../constants/constants';
import { dispatcher } from '../dispatcher/dispatcher';
const { ActionTypes } = Constants;

export const UserActions = {
    selectChanged: function (value) {
        SchematicAPI.resetSchematicNoPrompt();
        SchematicAPI.clearSubdivision();
        dispatcher.dispatch({
            type: ActionTypes.USER_CHANGED,
            role: [value]
        });
    },

    lataChanged: function (value) {
        dispatcher.dispatch({
            type: ActionTypes.PRINT_LATA_CHANGED,
            lata: value
        })
    },

    getActiveOverride: function (user) {
        var overrideCall = ServerAPI.getActiveOverrideForUser(user);

        overrideCall.done(function (data) {
            if (data.success) {
                if (data.data != null) {
                    dispatcher.dispatch({
                        type: ActionTypes.OVERRIDE_GRANTED,
                        override: JSON.stringify(data.data)
                    });
                    dispatcher.dispatch({
                        type: ActionTypes.SHOW_DEFAULT_TRACKS_VALUE_CHANGED,
                        value: true
                    });
                }
                else {
                    //If there is no override remove the default tracks
                    dispatcher.dispatch({
                        type: ActionTypes.SHOW_DEFAULT_TRACKS_VALUE_CHANGED,
                        value: false
                    });
                }
            }
        }).fail(function (error, xhr) {
            console.error("error occurred checking override on the server", error, xhr);
        });

    }
};
